import { NOTIFICATION_CATEGORIES, NOTIFICATION_TARGETS } from './notification-center.const'

const CRASH_TARGET_CATEGORIES = new Set([
  NOTIFICATION_CATEGORIES.CRASH_ADDED,
  NOTIFICATION_CATEGORIES.CRASH_MODIFIED,
  NOTIFICATION_CATEGORIES.CRASH_VALIDATED,
  NOTIFICATION_CATEGORIES.CRASH_REQUIRES_VALIDATION,
  NOTIFICATION_CATEGORIES.HOSPITAL_EXIT_DATE,
])

/**
 * Where the "View" action of a notification leads.
 * Deleted crashes have no destination; offline imports store the batch id in `crash_id`.
 * @param {{ category?: string, crash_id?: string|null, message?: string }} notification
 * @returns {string} one of NOTIFICATION_TARGETS
 */
export function getNotificationTarget(notification) {
  const { category, crash_id: crashId, message = '' } = notification ?? {}
  if (CRASH_TARGET_CATEGORIES.has(category) && crashId) return NOTIFICATION_TARGETS.CRASH
  if (category === NOTIFICATION_CATEGORIES.USER) return NOTIFICATION_TARGETS.USERS
  if (category !== NOTIFICATION_CATEGORIES.OFFLINE_IMPORT) return NOTIFICATION_TARGETS.NONE
  return message.startsWith('CSV') ? NOTIFICATION_TARGETS.CSV_IMPORTS : NOTIFICATION_TARGETS.ZIP_IMPORTS
}
